import {useId} from "react";
import {MagnifyingGlassIcon, XMarkIcon} from "@heroicons/react/24/outline";
import {fieldLabelClasses, fieldVariants} from "../../../general/fieldStyles.ts";
import {cn} from "../../../../lib/utils.ts";

interface AccountSearchInputProps {
    value: string;
    onChange: (value: string) => void;
}

export function AccountSearchInput({value, onChange}: AccountSearchInputProps) {
    const inputId = useId();

    return (
        <div className="flex flex-col gap-1.5">
            <label htmlFor={inputId} className={fieldLabelClasses}>
                Zoeken
            </label>
            <div className="relative w-[230px]">
                <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                    <MagnifyingGlassIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                </div>
                <input
                    id={inputId}
                    type="text"
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    placeholder="Rekening zoeken…"
                    className={cn(fieldVariants(), "pl-10 pr-10 shadow-sm")}
                />
                {value && (
                    <button
                        type="button"
                        onClick={() => onChange("")}
                        className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-400 hover:text-gray-600"
                        aria-label="Zoekopdracht wissen"
                    >
                        <XMarkIcon className="h-5 w-5" aria-hidden="true" />
                    </button>
                )}
            </div>
        </div>
    );
}
